import * as React from 'react';

import * as ManifestUI from '@project44/manifest-ds';

import { TWithManifestUIToaster } from '../types';

export const withManifestUIToaster: TWithManifestUIToaster = (
  ReactComponent,
) => {
  return (props) => (
    <>
      <ManifestUI.Toaster />
      <ReactComponent {...props} />
    </>
  );
};
